var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"apiDoc main-wrap"},[_c('div',{staticClass:"apiDoc-wrap"},[_c('div',{staticClass:"main-left"},[_c('my-menu')],1),_c('div',{staticClass:"main-right"},[_c('router-view')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }